/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { INotificationsSlice } from './types';

export const initialUserNotificationsState: INotificationsSlice = {
    notificationsList: {
        elements: [],
        newsAvailable: false,
    },
    notificationsSettings: null,
};

export const notificationsSlice = createSlice({
    name: 'userNotifications',
    initialState: initialUserNotificationsState,
    reducers: {
        setNotifications(state, action: PayloadAction<INotificationsSlice['notificationsList']>) {
            state.notificationsList = action.payload;
        },
        setNotificationsSettings(state, action: PayloadAction<Partial<INotificationsSlice['notificationsSettings']>>) {
            state.notificationsSettings = state.notificationsSettings
                ? { ...state.notificationsSettings, ...action.payload }
                : action.payload;
        },
        setNotificationsShowed(state, action: PayloadAction<number[]>) {
            state.notificationsList.elements = state.notificationsList.elements.map((el) => {
                if (action.payload.includes(el.id)) {
                    return { ...el, shownByPush: true };
                }
                return el;
            });
        },
    },
});

export const { setNotifications, setNotificationsSettings, setNotificationsShowed } = notificationsSlice.actions;
